import store from '../../store';

export const initializeApp = async (lang) => {
  try {
    await store.dispatch('AuthFirebase/initializeFirebase');

    await Promise.all([
      store.dispatch('Init/fetch'),
      store.dispatch('services/api/translation/fetchTranslations', lang, true),
      store.dispatch('services/api/language/setCurrentLanguage', lang),
    ]);

  } catch (error) {
    console.error('Error in initializeApp:', error);
  }
};
